"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = getUpdatedRowsWhenSelectAll;

function getUpdatedRowsWhenSelectAll() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$rows = params.rows,
      rows = _params$rows === undefined ? [] : _params$rows,
      maxRowSelection = params.maxRowSelection,
      _params$selectedRowsK = params.selectedRowsKeys,
      selectedRowsKeys = _params$selectedRowsK === undefined ? {} : _params$selectedRowsK;
  return rows.map(function (row, index) {
    if (index < maxRowSelection) {
      selectedRowsKeys[row.key] = true;
      return _extends({}, row, {
        isSelected: true
      });
    }

    return _extends({}, row, {
      isSelected: false,
      isDisabled: true
    });
  });
}